import { render, staticRenderFns } from "./ShippingDetail.vue?vue&type=template&id=45a06522&scoped=true"
import script from "./ShippingDetail.vue?vue&type=script&lang=js"
export * from "./ShippingDetail.vue?vue&type=script&lang=js"
import style0 from "./ShippingDetail.vue?vue&type=style&index=0&id=45a06522&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a06522",
  null
  
)

export default component.exports